<template>
  <TransitionBlock name="toast">
    <div v-if="visible" :class="[style.popup, style.success]">
      <IconBase :icon="successIcon" />
      <span>{{ text }}</span>
    </div>
  </TransitionBlock>
</template>

<script lang="ts">
import {defineComponent} from "vue";
import style from "@/elements/UI/overlay/Toast/Toast.module.scss";
import successIcon from "$images/icons/toast/Name=Success, Size=16, Tone=Default.svg";
import TransitionBlock from "@/layout/nav/components/TransitionBlock/TransitionBlock.vue";
import IconBase from "@/elements/UI/icon/IconBase.vue";

export default defineComponent({
  name: "ToastSuccess",
  components: {IconBase, TransitionBlock},
  props: {
    text: String
  },
  data() {
    return {
      style,
      successIcon,
      visible: false,
      timer: null as number | null
    };
  },

  methods: {
    show() {
      this.visible = true;

      if (this.timer) {
        clearTimeout(this.timer);
      }

      this.timer = window.setTimeout(() => {
        this.visible = false;
      }, 3000);
    }
  }
});
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition: all 0.3s ease;
}

.toast-enter-from {
  transform: translate(-50%, -40px);
  opacity: 0;
}

.toast-enter-to {
  transform: translate(-50%, 0);
  opacity: 1;
}

.toast-leave-from {
  transform: translate(-50%, 0);
  opacity: 1;
}

.toast-leave-to {
  transform: translate(-50%, -40px);
  opacity: 0;
}
</style>
